import type { Directive, DirectiveBinding } from 'vue';
import { createUUID } from '@/util/uuid';

interface AdobeDataComponent {
	'@type': string;
	'dc:title': string;
	'xdm:linkURL'?: string;
}

export default {
	mounted(el: HTMLElement, binding: DirectiveBinding) {
		const componentId = `${binding.value.name}-${createUUID()}`;
		const componentData: AdobeDataComponent = {
			'@type': `ltnext/components/3rdparty/${binding.value.name}/${binding.value.type}`,
			'dc:title': binding.value.title
		};
		if (binding.value.link) {
			componentData['xdm:linkURL'] = binding.value.link;
		}

		el.setAttribute('data-cmp-id', componentId);

		if (!window.adobeDataLayer) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			window.adobeDataLayer = [] as any;
		}

		window.adobeDataLayer.push({
			component: {
				[componentId]: componentData
			}
		});

		el.addEventListener('click', (event) => {
			const href = el.hasAttribute('href') ? el.getAttribute('href') : null;
			if (href) {
				event.preventDefault();
			}

			window.adobeDataLayer.push({
				event: 'cmp:click',
				eventInfo: {
					path: `component.${componentId}`
				}
			});

			if (href) {
				window.location.assign(href);
			}
		});
	},
	unmounted(el: HTMLElement) {
		el.removeEventListener('click', () => {});
	}
} satisfies Directive<HTMLElement>;
